import React, { Component } from "react";
import NavigationComponents from "../../Components/Navigation/Navigation";
import { OrganisationList } from "./OrganisationList";

export class PageNotFound extends Component {
    render() {
        let { message, status, statusMessage, organisations } = this.props;
        return (
            <div>
                {(status === 500 || status === 401) ? null : (
                    <NavigationComponents user={this.props.user} hideInviteButton={true} />
                )}
                <div className="container">
                    <div className="d-flex justify-content-center">
                        <div>
                            <img
                                src={`${process.env.REACT_APP_DATALAKESTORAGE_URL}/${process.env.REACT_APP_DATALAKESTORAGE_RESOURCES}/images/AccessDenied.jpg`}
                                alt="not found"
                                width={400}
                                height={400}
                            />
                        </div>
                        <div className="mt-5 pt-5">
                            <h3>
                                {status} - {statusMessage}
                            </h3>
                            <br />
                            {message}
                            <br />
                            <br />
                            <OrganisationList
                                organisations={organisations}
                            />
                        </div>
                    </div>
                </div>
            </div >
        );
    }

    componentWillUnmount() {
        localStorage.removeItem("error");
    }
}
